import { render, staticRenderFns } from "./SignifiCallPreview.vue?vue&type=template&id=ffc62854&"
import script from "./SignifiCallPreview.vue?vue&type=script&lang=js&"
export * from "./SignifiCallPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports